import { ResourceModel, Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class SuccessCaseContact extends DexResourceModel {

    @Field(String)
    public case_uuid: string = "";
    @Field(String)
    public contact_uuid: string = "";
    @Field(String)
    public contactType: string = "";

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
